
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuDaigomiHarajukuLunchCheeseImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/daigomi",
  title: "【とろとろ】原宿DAIGOMIでチーズをふんだんに使ったランチを食べよう",
  description: "チーズをガッツリ食べたいと思う時は、原宿・表参道・青山からアクセスができるDAIGOMIがオススメ。チーズ好きな人のために作られたお店のコンセプトがあり、どんなメニューもふんだんにチーズを利用したメニューが楽しめます。お店の雰囲気、チーズを使ったメニューをご紹介させていただきますので、ぜひご覧ください！",
  topImg: harajukuDaigomiHarajukuLunchCheeseImage,
  author: murakamiMasanori,
  tags: ["原宿", "有名店", "人気店", "お店の紹介", "食べログ高評価", "チーズ", "メニュー詳細", "デート", "女子会", "ガッツリ", "こってり", "インスタ映え"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`チーズをガッツリ食べたいと思う時は、原宿・表参道・青山からアクセスができる DAIGOMI がオススメです。`}</p>
    <p>{`チーズ好きな人のために作られたお店のコンセプトがあり、どんなメニューもふんだんにチーズを利用したメニューが楽しめます。`}</p>
    <p>{`一味違ったお店の雰囲気や、これでもか！と思うくらいたくさんトッピングされたチーズチーズを使ったメニューを写真付きでご紹介させていただきます！`}</p>
    <p>{`原宿のランチでチーズが食べたくなった時には、DAIGOMI へ！`}</p>
    <h2>{`DAIGOMI minamiaoyama`}</h2>
    <InstaImage postId="B18RR6qhfe5" mdxType="InstaImage" />
    <p>{`原宿から青山方面に向ったところに位置するチーズの専門店「DAIGOMI」は、「チーズ好きな人の、チーズ好きな人による チーズ好きな人になってもらう為のお店。」というコンセプトを掲げており、チーズ好きにはたまらないお店です。`}</p>
    <p>{`インスタグラムでは、大きなラクレットチーズを使ったチーズのメニューが、ランチ・ディナー問わずたくさん UP されているので、見たことがある方もいるのではないでしょうか。`}</p>
    <p>{`今回はそんなチーズの名店の DAIGOMI についてご紹介させていただきます。`}</p>
    <h2>{`おしゃれな空間`}</h2>
    <p>{`DAIGOMI は原宿から青山方面に位置しているということもあり、その街並みに併せて、店内も洗練されたデザインになっているのが特徴的です。
女子会、デート、家族づれなどランチのいろんなニーズに合わせて使いやすいのが嬉しいポイント。`}</p>
    <InstaImage postId="B2jHT66nkGx" mdxType="InstaImage" />
    <p>{`このようにお会計の代に、とけているチーズのデザインが施されています。こういった場所だとついつい写真を撮りたくなりますよね。`}</p>
    <h2>{`全てのメニューにチーズが`}</h2>
    <InstaImage postId="BqqwfoIAW6F" mdxType="InstaImage" />
    <InstaImage postId="B1Vv2UhFQeQ" mdxType="InstaImage" />
    <p>{`ランチのメニューはもちろんですが、お通しやソーセージなどの小さなメニューにもチーズが使用されています。もともとチーズがトッピングされているメニューもあれば、ラクレットチーズのように目の前で料理にたっぷりトッピングしてくれるメニューもあるので、とにかくチーズをランチでふんだんに楽しめるようになっています。`}</p>
    <p>{`インスタグラムではチーズを切り落とすトッピングの瞬間を収めた動画をたくさん見ることができるので、＃DAIGOMI で検索してみてください！`}</p>
    <h2>{`チーズのランチメニュー`}</h2>
    <h3>{`チーズをふんだんに使ったリゾット`}</h3>
    <InstaImage postId="Be2w7CmgYzW" mdxType="InstaImage" />
    <p>{`DAIGOMI の名物メニューですが、石焼の器にリゾットが見えないくらいトロトロのチーズがトッピングされたランチでも食べられるメニュー！ここからラクレットチーズをふんだんにトッピングすれが、文句なしの一品。`}</p>
    <h3>{`チーズをふんだんに使ったパスタ`}</h3>
    <InstaImage postId="B7lHHWWh5tz" mdxType="InstaImage" />
    <p>{`パスタにもふんだんにチーズを使用していて、こちらのパスタもたっぷりラクレットチーズをかけて食べることができる一品。普段のランチで食べるパスタとは少し違い、たっぷりチーズを堪能できる一品。`}</p>
    <h3>{`チーズをふんだんに使ったラクレットハンバーガー`}</h3>
    <InstaImage postId="B2bxYu5D6nQ" mdxType="InstaImage" />
    <p>{`ハンバーガーにもラクレットチーズをふんだんにトッッピングする一品です！ガッツリ食べ応えのあるハンバーガーに、大量のラクレットチーズをかけて食べるランチは、クセになってしまうような感覚。`}</p>
    <h3>{`カマンベールチーズのアヒージョ`}</h3>
    <InstaImage postId="BsaqSMIH3lx" mdxType="InstaImage" />
    <p>{`アヒージョにチーズ？と思う方もいるかもしれませんが、オリーブオイルに丸ごと一つのカマンベールチーズが投入されています。これが熱で溶け出してくるので、食べる時にはとろーりと伸びるチーズをオリーブオイルとパンと一緒に食べるランチは、普段は体験できない格別の味になっています。`}</p>
    <h3>{`黒毛和牛とたっぷりのチーズ`}</h3>
    <InstaImage postId="BqPzVr_hkbd" mdxType="InstaImage" />
    <p>{`高級な黒毛和牛のお肉とチーズを一緒に堪能できる贅沢な一品。塩と肉汁がチーズと混ざり合い、口の中で芳醇な風味を感じられる大人な原宿ランチの一品。`}</p>
    <h3>{`チーズのピザのクワトロフォルマッジ`}</h3>
    <InstaImage postId="Bmga7cpleqP" mdxType="InstaImage" />
    <p>{`チーズ好きにはたまらない、4 種のチーズをふんだんに使用したピザ。特に、ブルーチーズがピザの全体のアクセントになっており、ガッツリチーズのランチを堪能したい方には、このクワトロのピザがオススメ！`}</p>
    <h3>{`チーズ盛り合わせ`}</h3>
    <InstaImage postId="BwYmKzmHdl5" mdxType="InstaImage" />
    <p>{`とろとろのチーズだけでなく、チーズ本来の味を楽しみたいという方にはおすすめの一品。
ランチの時間から、ワインとチーズを食べることができたら、最高の休日になること間違いなし！`}</p>
    <hr></hr>
    <ShopInfoBox shopId="brr9d5q23akg00ce86t0" mdxType="ShopInfoBox" />
    <h3>{`おわりに　`}</h3>
    <p>{`原宿でとろとろチーズが食べられるチーズの名店 DAIGOMI をご紹介させていただきましたが、いかがでしたか？
これでもか！というくらいチーズをふんだんに利用した DAIGOMI で素敵なランチタイムをお過ごしいただければと思います！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;